import React, {useContext, useEffect, useState} from 'react';
import {
    Avatar,
    Button,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Collapse,
    Divider,
    Paper,
    Tooltip
} from "@mui/material";
import Typography from "@mui/material/Typography";
import {getDataLabel} from "../../../../utils/TableUtils";
import moment from "moment";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {amber, blue, deepOrange, green, lightBlue, orange, purple, red} from "@mui/material/colors";
import RoomTwoToneIcon from '@mui/icons-material/RoomTwoTone';
import {setOpenSnackbar} from "../../../../services/AppServices";
import {calculateAge, capitalizeWords} from "../../../../utils/GenericUtils";
import {AppContext} from "../../../../App";
import {useTheme} from "@mui/styles";
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import IconButton from "@mui/material/IconButton";
import clsx from "clsx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getStoricoPrenotazioneArray} from "../../../../services/TamponiServices";
import { Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {AccessTimeTwoTone} from "@mui/icons-material";
import base32Encode from "base32-encode";

const useStyles = makeStyles((theme) => ({
    actions: {
        height: 14
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        marginTop: -10,
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    customBadge: {
        "& .MuiBadge-anchorOriginBottomRightRectangular": {
            width: 82,
            transform: "scale(1) translate(40%, 60%)",
        }
    }
}));

const PrenotazioneCard = ({prenotazione, goToPrenotazione}) => {
    const theme = useTheme();
    const classes = useStyles();
    const appContext = useContext(AppContext);
    const [expanded, setExpanded] = React.useState(false);
    const [storico, setStorico] = useState([]);
    const [loading, setLoading] = useState(false);


    function toB32(str) {
        const buffer = new TextEncoder().encode(str);
        return base32Encode(buffer, 'RFC4648', {padding: false});
    }

    const handleExpandClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setExpanded(!expanded);
    };

    useEffect(() => {
        if (expanded) {
            setLoading(true);
            getStoricoPrenotazioneArray(prenotazione.id, (s) => setStorico(s))
                .then(() => setLoading(false))
        }
    }, [expanded, prenotazione])


    return (
        <React.Fragment>
            <CardActionArea onClick={() => goToPrenotazione(prenotazione)}>
                <CardHeader
                    style={{paddingBottom: 2}}
                    title={<Typography
                        variant={"subtitle1"}><b>{prenotazione.category} - {prenotazione.subCategory}</b> {prenotazione.tipo}
                    </Typography>}
                    subheader={
                        prenotazione.active ?
                            <Typography variant={"body2"} color={"textSecondary"}>
                                Prenotazione con stato <b>{prenotazione.stato}</b> attualmente in gestione da parte
                                di <b>{prenotazione.lastModify}</b>
                            </Typography> :
                            <Typography variant={"body2"} color={"textSecondary"}>
                                Ultima modifica: <b>{getDataLabel(prenotazione?.updated)}</b> da parte
                                di <b>{prenotazione.lastModify ? prenotazione.lastModify : "System"}</b>
                            </Typography>
                    }
                    avatar={
                        <Tooltip
                            title={prenotazione?.cliente === false || prenotazione?.cliente == null ? "Nuovo cliente" : ""}
                            arrow>
                            <Avatar style={{
                                marginRight: 10,
                                boxShadow: prenotazione?.cliente === false || prenotazione?.cliente == null
                                    ? '0 0 18px 5px rgba(0, 0, 255, 0.6)' // Alone dorato
                                    : 'none',
                                cursor: 'pointer'
                            }}>
                                <SVG src={multiavatar(prenotazione?.soggetto?.codF)}/>
                            </Avatar>
                        </Tooltip>
                    }
                    action={
                        <Tooltip title={"data inserimento"}>
                            <Typography
                                style={{display: "flex", alignItems: "center"}}
                                variant={"body2"}
                                color={"textSecondary"}>{moment(prenotazione.dataInserimento).format("DD/MM/YYYY HH:mm") + " "}</Typography>
                        </Tooltip>
                    }
                />
                <CardContent style={{paddingTop: 8}}>
                    <div style={{display: "flex"}}>
                        <Tooltip title={"Clicca per copiare"}>
                            <Button variant={"text"}
                                    style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
                                    component={"div"}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        navigator?.clipboard?.writeText(prenotazione.id).then(() => {
                                            setOpenSnackbar("info", "ID copiato negli appunti", appContext.dispatch);
                                        })
                                    }}>
                                <b>{"ID: " + prenotazione.id}</b>
                            </Button>
                        </Tooltip>
                        <Divider orientation={"vertical"}
                                 style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/><Tooltip
                        title={"Clicca per copiare"}>
                        <Button variant={"text"}
                                style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
                                component={"div"}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    navigator?.clipboard?.writeText(toB32('ATL' + prenotazione.cliente?.idSoggetto)).then(() => {
                                        setOpenSnackbar("info", "Codice Cliente copiato negli appunti", appContext.dispatch);
                                    })
                                }}>
                            <b>{prenotazione.cliente ? "COD: " + toB32('ATL' + prenotazione.cliente?.idSoggetto) : 'COD: N/A'}</b>
                        </Button>
                    </Tooltip>
                        <Divider orientation={"vertical"}
                                 style={{height: 16, marginLeft: 10, marginRight: 10, alignSelf: "center"}}/>
                        <Tooltip title={"Clicca per copiare"}>
                            <Button variant={"text"}
                                    style={{padding: 2, color: theme.palette.text.secondary, textTransform: "none"}}
                                    component={"div"}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        navigator?.clipboard?.writeText(prenotazione.cliente?.codF).then(() => {
                                            setOpenSnackbar("info", "Documento copiato negli appunti", appContext.dispatch);
                                        })
                                    }}>
                                {
                                    <b>{prenotazione.cliente ?
                                        (prenotazione.cliente?.codF + " , " + capitalizeWords(prenotazione.cliente?.nome) + " " + capitalizeWords(prenotazione.cliente?.cognome) + (prenotazione.cliente?.dataNascita ? (", " + calculateAge(prenotazione.cliente.dataNascita) + " anni") : ""))
                                        : (capitalizeWords(prenotazione.dynamicFormData.nome) + ' ' + capitalizeWords(prenotazione.dynamicFormData.cognome) + (prenotazione.dynamicFormData.data_nascita ? (", " + calculateAge(prenotazione.dynamicFormData.data_nascita) + " anni") : ''))
                                    }</b>
                                }
                            </Button>
                        </Tooltip>
                    </div>
                    <Typography variant={"body2"} color={"textSecondary"} style={{marginTop: 10}}>
                        {prenotazione.summary ? prenotazione.summary : <i>non sono presenti note</i>}
                    </Typography>
                    <br/>
                    {
                        prenotazione.criterioEpidemiologico === "TC" &&
                        <Chip
                            avatar={<Avatar
                                style={{
                                    width: 24,
                                    height: 24,
                                    backgroundColor: purple[700],
                                    color: "#FFF",
                                    fontSize: 12
                                }}>TC</Avatar>}
                            label={"Tampone di controllo"}
                            style={{
                                marginRight: 8,
                                marginTop: 8,
                                backgroundColor: purple[500],
                                color: "#FFF"
                            }}/>
                    }
                    {
                        prenotazione.criterioEpidemiologico === "TD" &&
                        <Chip
                            avatar={<Avatar
                                style={{
                                    width: 24,
                                    height: 24,
                                    backgroundColor: deepOrange[700],
                                    color: "#FFF",
                                    fontSize: 12
                                }}>TD</Avatar>}
                            label={"Tampone di diagnosi"} style={{
                            marginRight: 8,
                            marginTop: 8,
                            backgroundColor: deepOrange[500],
                            color: "#FFF"
                        }}/>
                    }
                    {
                        prenotazione.motivazione?.includes("Prioritaria SISP") &&
                        <Chip label={"PRIORITARIA SISP"} color={"default"} style={{
                            marginRight: 8,
                            marginTop: 8,
                            backgroundColor: blue[700],
                            color: "#FFF"
                        }}
                              icon={<NotificationsActiveTwoToneIcon style={{color: "#FFF", fontSize: 18}}/>}
                        />
                    }
                    {
                        prenotazione.motivazione?.includes("Prioritaria CTC") &&
                        <Chip label={"PRIORITARIA CTC"} color={"default"} style={{
                            marginRight: 8,
                            marginTop: 8,
                            backgroundColor: red[700],
                            color: "#FFF"
                        }} icon={<NotificationsActiveTwoToneIcon style={{color: "#FFF", fontSize: 18}}/>}/>
                    }
                    <Chip
                        avatar={<Avatar style={{backgroundColor: amber[800]}}><RoomTwoToneIcon
                            style={{color: "#FFF", fontSize: 18}}/></Avatar>}
                        label={prenotazione.location}
                        style={{
                            backgroundColor: amber[500], marginRight: 8,
                            marginTop: 8,
                        }}/>
                    <Chip
                        label={moment(prenotazione.startDateTime).format("HH:mm DD/MM/YYYY")}
                        avatar={<Avatar
                            style={{backgroundColor: green[500], color: "#FFF"}}><AccessTimeTwoTone/></Avatar>}
                        color={"default"}
                        style={{
                            marginRight: 8,
                            marginTop: 8,
                            backgroundColor: green[700],
                            color: "#FFF"
                        }}/>
                    {prenotazione.dataEffettiva && <Chip
                        label={moment(prenotazione.dataEffettiva).format("DD/MM/YYYY")}
                        avatar={<Avatar style={{backgroundColor: green[700], color: "#FFF"}}><b>Re</b></Avatar>}
                        color={"default"}
                        style={{
                            marginRight: 8,
                            marginTop: 8,
                            backgroundColor: green[500], color: "#FFF"
                        }}/>}
                </CardContent>
            </CardActionArea>
            <CardActions className={classes.actions} disableSpacing>
                <Tooltip title={"Mostra storico prenotazione"}>
                    <IconButton
                        size={"small"}
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon/>
                    </IconButton>
                </Tooltip>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    {
                        loading ? <Skeleton/> :
                            storico.length === 0 ? "Non c'è storico" :
                                storico
                                    .sort((a, b) => new Date(a.dataModifica) - new Date(b.dataModifica))
                                    .map((item, index) => {
                                        return (
                                            <Paper elevation={0} key={index} id={"paper-storico" + index}
                                                   style={{
                                                       backgroundColor: item.lastModify?.toLowerCase().includes("richiesta utente") ?
                                                           (theme.palette.mode === "light" ? orange[50] : orange[800]) :
                                                           (theme.palette.mode === "light" ? lightBlue[50] : lightBlue[800]),
                                                       borderRadius: 24,
                                                       padding: 16,
                                                       marginRight: 100,
                                                       marginTop: 16
                                                   }}>
                                                <Typography variant={"subtitle2"} color={"textSecondary"}>
                                                    <b>{item.lastModify}</b> in
                                                    data: {moment(item.dataModifica).format("DD/MM/YYYY - HH:mm")}
                                                </Typography>
                                                <Typography variant={"subtitle1"}>
                                                    {item.note?.replaceAll(/#(\S*)/g, "")}
                                                </Typography>
                                            </Paper>
                                        );
                                    })
                    }
                </CardContent>
            </Collapse>
        </React.Fragment>
    );
};

export default React.memo(PrenotazioneCard);
